/**
 * 安全的本地存储适配器
 * 支持 SSR、Node.js 运行时及标准浏览器环境
 */

function getLocalStorage(): Storage | null {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage
  }
  if (typeof globalThis !== 'undefined' && (globalThis as unknown as { localStorage?: Storage }).localStorage) {
    return (globalThis as unknown as { localStorage: Storage }).localStorage
  }
  return null
}

const memoryStorage = new Map<string, string>()

export function getStorageItem(key: string): string | null {
  const storage = getLocalStorage()
  if (storage) {
    return storage.getItem(key)
  }
  return memoryStorage.get(key) ?? null
}

export function setStorageItem(key: string, value: string): void {
  const storage = getLocalStorage()
  if (storage) {
    storage.setItem(key, value)
  } else {
    memoryStorage.set(key, value)
  }
}

export function removeStorageItem(key: string): void {
  const storage = getLocalStorage()
  if (storage) {
    storage.removeItem(key)
  } else {
    memoryStorage.delete(key)
  }
}
